import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import moment from 'moment-timezone';
import {Select} from 'ui-library';
import {range} from 'lodash';
import i18n from 'i18n';

import {getStatics} from 'config/app';

const CURRENT_YEAR = new Date().getFullYear();
const OLDEST_YEAR = 1905;
const DEFAULT_STATE = {
  day_input: -1,
  month_input: -1,
  year_input: -1,

  day: null,
  month: null,
  year: null, 

  inicialized: false
};

const yearOptions = range(CURRENT_YEAR, OLDEST_YEAR, -1);

const DateSelect = createClass({
  propTypes: {
    initialDate: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool, 
    finalYearGap: PropTypes.number
  },  

  componentDidUpdate(){
    const {inicialized} = this.state;
    const {initialDate} = this.props;

    if(inicialized || !initialDate) return;

    const newState = this.getNewState();
    this.setState(newState);
  },

  getInitialState() {
    return this.getNewState();
  },

  getNewState() {
    const {initialDate} = this.props;

    if (!initialDate) return DEFAULT_STATE;
    
    const dateWithoutTime = initialDate.split('T')[0];
    const date = moment(dateWithoutTime).toDate();
    const initialYearIndex = this.getInitialYearIndex(date.getFullYear());

    return {
      day_input: date.getDate() - 1,
      month_input: date.getMonth(),
      year_input: initialYearIndex - 1,

      day: date.getDate(),
      month: date.getMonth(),
      year: date.getFullYear(), 
      inicialized: true
    };
  },

  onDayChange(event, index, value) {
    this.setState({
      day_input: index,
      day: parseInt(value, 10)
    }, this.dateChange);
  },

  onMonthChange(event, index) {
    this.setState({
      month_input: index,
      month: parseInt(index, 10)
    }, this.dateChange);
  },

  onYearChange(event, index, value) {
    this.setState({
      year_input: index,
      year: parseInt(value, 10)
    }, this.dateChange);
  },

  getInitialYearIndex(year) {
    let index = 0;

    while (yearOptions[index] && yearOptions[index] !== year) {
      index++;
    }

    return index;
  },

  dateChange() {
    const {months} = getStatics();
    if (this.state.month && this.state.day > months[this.state.month].days) {
      this.setState({
        day_input: -1,
        day: null
      });
      this.props.onChange(null);
      return;
    }

    // if something is missing, return...
    if (!(this.state.year !== null && this.state.month !== null && this.state.day !== null) ) {
      return;
    }
    let newDate = new Date(this.state.year, this.state.month, this.state.day);

    this.props.onChange(newDate);
  },

  render() {
    const {className, disabled = false, finalYearGap = 0} = this.props;
    const {months} = getStatics();
    const monthOptions = months.map(item => item.name);
    const selectsClassName = `${className} margin-right-Hx`;
    const dayOptions = ( () => {
      let years = [];
      let x;
      for (x = 1; x <= (this.state.month ? months[this.state.month].days : 31); x++) years.push(x);
      return years;
    })();

    const yearFiltered = yearOptions.slice(finalYearGap,yearOptions.length)

    return (
      <div className='vf-dateselect vf-clearfix'>
        <Select
          disabled={disabled}
          options={dayOptions}
          onChange={this.onDayChange}
          value={this.state.day_input}
          className={selectsClassName}
          title={i18n.get('DATE_SELECT_DAY')}
          id='day-select'
        />
        <Select
          disabled={disabled}
          options={monthOptions}
          onChange={this.onMonthChange}
          value={this.state.month_input}
          className={selectsClassName}
          title={i18n.get('DATE_SELECT_MONTH')}
          id='month-select'
        />
        <Select
          disabled={disabled}
          options={yearFiltered}
          onChange={this.onYearChange}
          value={this.state.year_input}
          className={selectsClassName}
          title={i18n.get('DATE_SELECT_YEAR')}
          id='year-select'
        />
      </div>
    );
  }

});

module.exports = DateSelect;
